'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint react/require-default-props: 0 */
function DefaultCloseButton(_ref) {
  var closeToast = _ref.closeToast;

  return _react2.default.createElement(
    'button',
    {
      className: 'toastify__close',
      type: 'button',
      onClick: closeToast
    },
    '\u2716'
  );
}

DefaultCloseButton.propTypes = {
  closeToast: _propTypes2.default.func
};

exports.default = DefaultCloseButton;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-toastify/lib/DefaultCloseButton.js
 ** module id = 3566
 ** module chunks = 0
 **/